export const FORM_DEFAULT_VALUES = {
  update_titles: false,
  workspace_id: null,
  copy_involved_users: false,
  copy_comments: false,
  issues: [],
};
